export default __webpack_public_path__ + "search-examples-search-ui-and-maps-sdk-thumbnail-960-f4cae3ac874d0b089cd61d1bc3915964.webp";